import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import AdvertisersDashboard from "./components/AdvertisersDashboard";
import Breadcrumps from "../../components/modules/Breadcrumps";
import NoAdvertisersFound from "./components/NoAdvertisersFound";
import PageLayout from "../../layouts/PageLayout";
import classes from "./AdvertisersListPage.module.scss";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";

const breadcrumps = [
  { label: "Home", link: "/dashboard", active: false },
  { label: "Advertisers", link: "/advertisers", active: true },
];

const AdvertisersListPage: React.FC = () => {
  // advertisers
  const advertisers = useSelector((state: ReduxApplicationState) => state.agency?.advertisers);

  const location = useLocation();
  const history = useHistory();

  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    const brandgenAdvertiserId = localStorage.getItem("currentBrandgenAdvertiserId") as string;
    if (queryParams.has("code")) {
      const hubspotCredentialCode = window.location.href.split("?").slice(-1)[0].split("=").slice(-1)[0].trim();
      history.push(`/advertisers/${brandgenAdvertiserId}?code=${hubspotCredentialCode}`);
    }
  }, [history, location.search]);

  return (
    <PageLayout heading="Advertisers">
      <Breadcrumps breadcrumps={breadcrumps} className={classes.breadcrumps} />
      {advertisers?.length ? <AdvertisersDashboard advertisers={advertisers} /> : <NoAdvertisersFound />}
    </PageLayout>
  );
};

export default AdvertisersListPage;
